import {
  generateRecaptchaToken
} from "./chunk-ZD2ESESY.mjs";
import {
  solveGeeTest
} from "./chunk-G4NYY657.mjs";
import {
  getCaptchaProvider,
  takePresolvedGeeTest
} from "./chunk-P2B2TNGX.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/grecaptcha/resolve.ts
var resolveCaptcha = (_0, ..._1) => __async(null, [_0, ..._1], function* (action, { unattended } = {}) {
  var _a;
  if (getCaptchaProvider() === "geetest") {
    if (unattended) {
      return { captcha_provider: "geetest" };
    }
    const captcha = (_a = takePresolvedGeeTest()) != null ? _a : yield solveGeeTest();
    return { captcha_provider: "geetest", captcha };
  }
  return { captcha_provider: "google", captcha: yield generateRecaptchaToken(action) };
});
var appendCaptcha = (form, { captcha_provider, captcha }) => {
  form.append("captcha_provider", captcha_provider);
  if (typeof captcha === "string") {
    form.append("captcha", captcha);
    return;
  }
  Object.entries(captcha != null ? captcha : {}).forEach(([key, value]) => {
    if (value) {
      form.append(`captcha[${key}]`, value);
    }
  });
};

export {
  resolveCaptcha,
  appendCaptcha
};
//# sourceMappingURL=chunk-UELQYFJ7.mjs.map